export default __webpack_public_path__ + "static/media/pin.206fa53e.svg";